import "react-datepicker/dist/react-datepicker.css";
import "./InputListField.styles.scss";
import React from "react";
import StringField from "../StringField";
import { Field } from "types";

interface InputListFieldProps extends Field {
  id?: string;
  readOnly?: boolean;
}

const InputListField = ({
  label,
  onChange,
  value,
  ...props
}: InputListFieldProps) => {
  const config = JSON.parse(props.config ? props.config : null);
  const values = JSON.parse(String(value ? value : "[]") || "[]");
  const fields = [];
  if (props.config) {
    for (let i = 0; i < config.length; i++) {
      let placeholder;
      if (config.placeholderPattern === "{{index}}.") {
        placeholder = (config.placeholderPattern || "").replace(
          /{{index}}/g,
          String(i + 1)
        );
      } else {
        placeholder = config.placeholderPattern[i];
      }
      const hint = config.hintPattern ? config.hintPattern[i] : null;
      fields.push(
        <StringField
          {...props}
          name={props.uuid ? props.uuid + i : props.name + i}
          key={props.uuid ? props.uuid + i : props.name + i}
          placeholder={placeholder}
          readOnly={props.readOnly}
          value={values[i] || ""}
          onChange={(event) => {
            values[i] = event.target.value;
            onChange && onChange(JSON.stringify(values));
          }}
          hint={hint !== "null" ? hint : ""}
          label=""
        />
      );
    }
  }
  return (
    <div className="input-list-field">
      <label className="input-list-field__label">{label}</label>
      {fields}
    </div>
  );
};

export default InputListField;
